import { LeadImportApiError } from '../services/leadImportService';

/**
 * Checks if an error is a LeadImportApiError with a specific HTTP status code.
 */
export function isApiErrorWithStatus(error: unknown, status: number): boolean {
  return error instanceof LeadImportApiError && error.status === status;
}

/**
 * Checks if an error is a 404 Not Found error from the Lead Import API.
 */
export function isNotFoundError(error: unknown): boolean {
  return isApiErrorWithStatus(error, 404);
}

/**
 * Checks if an error is a 400 Bad Request error from the Lead Import API.
 * Components can use this to display inline validation errors.
 */
export function isBadRequestError(error: unknown): boolean {
  return isApiErrorWithStatus(error, 400);
}

/**
 * Extracts the error message body from a LeadImportApiError (for 400 inline display).
 * Returns null if the error is not a LeadImportApiError.
 */
export function getApiErrorBody(error: unknown): any | null {
  if (error instanceof LeadImportApiError) {
    return error.body;
  }
  return null;
}
